import { useState } from "react"
import { HeadingRow, StatusBlock, StatusIndicator } from "cai-fusion"

import { ReactComponent as IconApproved } from "../../../../../images/icon-approved.svg"
import { ReactComponent as IconCancel } from "../../../../../images/icon-cancel.svg"
import { useSiftV2 } from "../../../contexts/siftV2Context"

const SiftOpportunityFeedbackBlock = () => {

    const { placeholderReviews } = useSiftV2();

    return (
        <div className="o-block l-mb-sm">
            <HeadingRow 
                className="l-mb-xs"
                isSecondary
                title="Feedback"
                size={3}
            />
            <div className="row l-pt-xs">
                <div className="col-md-12">
                    {placeholderReviews.map((user) => (
                        <FeedbackItem key={user?.name} name={user?.name ?? ""} feedback={user?.approve ?? ""} />
                    ))}
                </div>
            </div>
        </div>
    )
}

const FeedbackItem = ({name, feedback}) => {
    return (
        <StatusBlock
            isFlex
            className="l-mb-xs"
            indicatorColor={feedback === "yes" ? "green" : "red"}
            Icon={feedback === "yes" ? IconApproved : IconCancel}
            label={name}
        />
    )
}

export default SiftOpportunityFeedbackBlock;